import React, { useEffect, useState } from "react";
import moment from "moment";

import WidgetBox from "../WidgetBox";
import PerformBoxFlexible from "../../../components/Hero/PerformBoxFlexible";

const QuoteOfTheDay = ({
  widget = {},
  reFetch,
  setReFetch,
  showPerformBox,
  showCharts = false,
  isSmallScreen = false
}) => {
  const [randomNumber, setRandomNumber] = useState(0);

  useEffect(() => {
    if (widget.multilineUserInput && widget.multilineUserInput.length) {
      const currentDate = moment();
      const dayOfYear = currentDate.dayOfYear();

      const indexOfTodaysQuote =
        dayOfYear % (widget.multilineUserInput.length - 1);

      if (widget.multilineUserInput[indexOfTodaysQuote]) {
        setRandomNumber(indexOfTodaysQuote);
      } else {
        setRandomNumber(0);
      }
    }
  }, []);

  return showPerformBox ? (
    <PerformBoxFlexible
      title={widget.title}
      amount={
        widget.multilineUserInput && widget.multilineUserInput.length
          ? widget.multilineUserInput[randomNumber]
          : widget.userInput || ""
      }
      showGraph={false}
      showCharts={showCharts}
      isSmallScreen={isSmallScreen}
    />
  ) : (
    <WidgetBox
      widget={widget}
      widgetTitle={widget.title}
      widgetMetrics={widget.userInput || ""}
      reFetch={reFetch}
      setReFetch={setReFetch}
    />
  );
};

export default QuoteOfTheDay;
